module.exports = __webpack_public_path__ + "img/bottom.fdcc2b04.png";